<template>
  <div>
    <v-bottom-navigation
      v-model="activeValue"
      v-show="GET_BOTTOM_NAV_FLAG"
      fixed
      class="bottom-nav"
      :class="paddingByOs"
      ondragstart="return false"
    >
      <!----다국어 ejkim {{ $t('메인') }}-->
      <v-btn value="main" :ripple="false" to="/main">
        <span>메인</span>
        <!--<span>{{ $t('메인') }}</span>-->

        <v-icon v-if="activeValue === 'main'">mdi-home</v-icon>
        <v-icon v-else>mdi-home-outline</v-icon>
      </v-btn>

      <v-btn value="calendar" :ripple="false" to="/calendar">
        <span>일정</span>
        <v-icon v-if="activeValue === 'calendar'">mdi-calendar-range</v-icon>
        <v-icon v-else>mdi-calendar-range-outline</v-icon>
      </v-btn>

      <v-btn value="search" :ripple="false" to="/memberSearch">
        <span>직원찾기</span>
        <v-icon>mdi-magnify</v-icon>
      </v-btn>

      <v-btn value="menu" :ripple="false" to="/allMenu">
        <span>전체</span>
        <v-icon>mdi-menu</v-icon>
      </v-btn>
      <!-- <v-btn to="/callAppTest"> 앱 테스트 </v-btn> -->
    </v-bottom-navigation>
  </div>
</template>

<script>
/* 하단 메뉴 컴포넌트 */
import { mapGetters } from 'vuex';
export default {
  data: () => ({ activeValue: 'main' }),

  computed: {
    ...mapGetters(['GET_BOTTOM_NAV_FLAG', 'IS_IOS']),

    // os별 bottomNav 높이 조정
    paddingByOs() {
      return this.IS_IOS ? 'apple' : 'android';
    },
  },
};
</script>
